<template>
  <div class="ai-status-pills">
    <span class="ai-main"><i>✦</i> AI自动优化图片并识别填充零件信息</span>
  </div>
</template>

<script>
export default {
  name: 'AiStatusPills',
  props: {
    part: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-status-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.ai-status-pills span {
  height: 26px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid #dae6f5;
  border-radius: 999px;
  color: #8795ad;
  background: #f9fbff;
  font-size: 12px;
}
.ai-status-pills span:not(.ai-main)::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #b6c2d4;
}
.ai-status-pills .ai-main {
  border-color: #b8d5ff;
  color: #006eb7;
  background: linear-gradient(90deg, #fff, #f4fbff);
  font-weight: 800;
  box-shadow: 0 8px 20px rgba(21, 100, 205, .08);
}
.ai-status-pills i {
  color: #2275ff;
  font-style: normal;
}
</style>
